export default __webpack_public_path__ + "static/media/income_proj_04.a196f56e.png";